import React from 'react';
import { Lead, CrmUser } from '../../../../types';
import { ContactInfoSection } from './ContactInfoSection';
import { DealInfoSection } from './DealInfoSection';

interface LeadInfoFormProps {
    lead: Lead;
    crmUsers: CrmUser[];
    onInputChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => void;
    onObservationsDraftChange?: (html: string) => void;
}

export const LeadInfoForm: React.FC<LeadInfoFormProps> = ({
    lead,
    crmUsers,
    onInputChange,
    onObservationsDraftChange,
}) => {
    return (
        <section aria-label="Dados da negociação" className="space-y-s6">
            <ContactInfoSection lead={lead} onInputChange={onInputChange} />
            <DealInfoSection
                lead={lead}
                crmUsers={crmUsers}
                onInputChange={onInputChange}
                onObservationsDraftChange={onObservationsDraftChange}
            />
        </section>
    );
};
